// import { permissionService } from 'shared/services';

import OrderList from '../containers/OrderList/OrderList.container';
import OrderDetail from '../containers/OrderDetail/OrderDetail.container';
import PartnerList from '../containers/PartnerList/PartnerList.container';
import PartnerDetail from '../containers/PartnerDetail/PartnerDetail.container';
import PartnerEdit from '../containers/PartnerEdit/PartnerEdit.container';
import ClientList from '../containers/ClientList/ClientList.container';
import deliveryRoute from '.';

// const { checkPermission } = permissionService;

const DeliveryNavigation = () => [
  { path: deliveryRoute.ORDER_LIST, component: OrderList },
  // ...(checkPermission('Order List:read', true)
  //   ? [{ path: deliveryRoute.ORDER_LIST_FILTER, component: OrderList }]
  //   : []),
  { path: deliveryRoute.ORDER_LIST_FILTER, component: OrderList },
  { path: deliveryRoute.ORDER_DETAIL, component: OrderDetail },
  { path: deliveryRoute.PARTNER_LIST, component: PartnerList },
  { path: deliveryRoute.PARTNER_LIST_FILTER, component: PartnerList },
  { path: deliveryRoute.PARTNER_DETAIL, component: PartnerDetail },
  { path: deliveryRoute.PARTNER_EDIT, component: PartnerEdit },
  { path: deliveryRoute.CLIENT_LIST, component: ClientList },
  { path: deliveryRoute.CLIENT_LIST_FILTER, component: ClientList },
];

export default DeliveryNavigation;
